import { useMemo } from 'react'
import { useQuery } from 'react-query'

import { QueryKeys } from '../../../../../enums/queryKeys'
import { TaxationType } from '../enums/taxationType'
import { fetchTaxationType } from '../query-api'

export const useFetchTaxationType = (organizationId?: string) => {
  const { data, isFetching, isLoading, isError } = useQuery(
    [QueryKeys.TaxationTypeSettings, organizationId],
    () => fetchTaxationType(organizationId as string),
    { enabled: !!organizationId },
  )
  const taxationType: TaxationType | undefined = useMemo(
    () => data?.settings.taxationType,
    [data?.settings.taxationType],
  )

  return { taxationType, isFetching, isLoading, isError }
}
